import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class File extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get id() {
    return this.system.id;
  }

  get name() {
    return get(this, '_plik.value', []).map(item => item.name);
  }

  get description() {
    return get(this, '_nazwa.value', '');
  }

  get url() {
    return get(this, '_plik.value', []).map(item => item.url);
  }

  get size() {
    return get(this, '_plik.value', []).map(item => item.size);
  }

  get format() {
    return get(this, '_format.value', '');
  }

  get attachments() {
    let attachments = [];
    for (let i = 0; i < this.url.length; i++) {
      attachments.push({
        url: this.url[i],
        name: this.name[i]
      });
    }
    return attachments;
  }
}



// WEBPACK FOOTER //
// ./src/models/File.js